/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./../lib/httpClient.ts";
import {
  OperateArtifactRequestDTO,
  PageResponse,
  Response,
} from "././index.d.ts";

export class Artifacts<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Operate artifact details, example: Proof Reader Approval, Regulatory Approval, Supply Chain Approval, QA Review, QA Approval
   *
   * @tags artifacts
   * @name OperateArtifact
   * @request POST:/artifacts/{id}/operation
   * @secure
   */
  operateArtifact = (
    id: number,
    data: OperateArtifactRequestDTO,
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/artifacts/${id}/operation`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description list artifact with request body
   *
   * @tags artifacts
   * @name ListArtifact
   * @request GET:/artifacts
   * @secure
   */
  listArtifact = (
    query: {
      /**
       * Current page number
       * @format int32
       */
      number: number;
      /**
       * the page size
       * @format int32
       */
      size: number;
      /** the fields to return, eg: ["name","description","createdAt"] */
      fields: string;
      /** the search keyword */
      keyword?: string;
      /** the logic operator, eg: and, or */
      logicOperator?: string;
      /** the search filters, eg: [{"field":"name","operator":"contains","value":"demo"},{"field":"description","operator":"contains","value":"demo"}] */
      filters?: string;
      /** the sort orders, eg: [{"field":"createdAt","sort":"desc"},{"field":"updatedAt","sort":"asc"}] */
      sort?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PageResponse, PageResponse | Response>({
      path: `/artifacts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get artifact details by ID
   *
   * @tags artifacts
   * @name GetArtifact
   * @request GET:/artifacts/{id}
   * @secure
   */
  getArtifact = (id: number, params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/artifacts/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
